/**
 * Qualtrics Feedback/Survey Component
 */
import React, { Component } from 'react';
import { Button } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import Page from '../lib/page';
import { isQualtricsFeedbackEnabled } from '../lib/globalHelper';
import { trackLink, trackPage } from '../lib/analytics-helper';
import i18n from '../lib/reacti18n';

const labels = {
  surveyLabel: i18n.message('smarthelp/contactLinksOption.label.survey'),
  surveyMessage: i18n.message('smarthelp/contactLinksOption.message.survey'),
  surveyButtonLabel: i18n.message('smarthelp/contactLinksOption.label.surveyButton'),
};

class QualtricsFeedbackComponent extends Component {
  static surveyButtonClicked() {
    // FPTI For feedback option click
    trackLink({ id: Page.getFPTIPageId(), link: 'smarthelp-footer-survey' });

    try {
      // eslint-disable-next-line no-undef
      if (typeof PAYPAL === 'object' && PAYPAL.analytics) {
        // eslint-disable-next-line no-undef
        PAYPAL.analytics.reloadQualtrics('smarthelpnodeweb-feedbacklink-CH-dec2020');
      }
    } catch (e) {
      // Error FPTI For feedback option click, if there is any error on the feedback link
      trackLink({ id: Page.getFPTIPageId(), link: 'smarthelp-footer-survey-click-error' });
    }
  }

  render() {
    // Checking remote config for qualtrics feedback
    // if we dont want to show up qualtrics component we can pass display false from props
    if (isQualtricsFeedbackEnabled() && this.props.display) {
      trackPage({ id: `qualtricsFeedback${Page.getFPTIPageId()}`, link: 'smarthelp-footer-survey' });
      return (
        <div className="feedback-component">
          <h3 className="feedback-component__survey_label">{labels.surveyLabel}</h3>
          <div className="feedback-component__feedback-details">
            <p>{Page.getHTMLElement({ message: labels.surveyMessage, useHTML: true })}</p>
            <Button
              theme="v2"
              className="feedback-component__feedback-details__survey_button"
              data-testid="feedback-component-feedback-details-survey-btn"
              onClick={() => {
                QualtricsFeedbackComponent.surveyButtonClicked();
              }}
            >
              {labels.surveyButtonLabel}
            </Button>
          </div>
        </div>
      );
    }
    // If the remote config is not enabled returning empty div tag
    return <div />;
  }
}

QualtricsFeedbackComponent.propTypes = {
  display: PropTypes.bool.isRequired,
};

QualtricsFeedbackComponent.defaultProps = {
  display: true,
};

export default QualtricsFeedbackComponent;
